import React, { useMemo } from "react";
import PropTypes from "prop-types";
import {
  HeaderNavigationItemContainer,
  HeaderNavigationItemLinkContainer,
  HeaderNavigationItemIconContainer,
  HeaderNavigationItemIconTitle,
  HeaderNavigationItemHighlightContainer,
} from "./HeaderNavigationItem.styled";
import { useLocation } from "react-router-dom";
import { compareRoutes, isInRoute } from "util/routeHelpers";
import { PAGES } from "constants/pages";
import { ReactComponent as HighlightIcon } from "../../../../assets/images/svg/arrow-up-right-black.svg";

const itemLink = [PAGES.CONTACT.route];
const itemHighlight = [PAGES.OPEN_POSITIONS.route];

const HeaderNavigationItem = (props) => {
  const location = useLocation();
  const singleRoutePath = useMemo(() => {
    const pathArray = props?.route?.route?.split("/");
    if (pathArray?.[pathArray?.length - 1] === "*")
      pathArray.splice(pathArray?.length - 1, 1);
    return pathArray.join("/");
  }, [props?.route]);

  const highlightTitle = useMemo(() => {
    return compareRoutes(singleRoutePath, PAGES.CONTACT.route);
  }, [props?.route]);

  const isInThisRoute = useMemo(() => {
    if (
      location?.pathname === "/" &&
      compareRoutes(singleRoutePath, PAGES.HOME.route)
    )
      return true;
    return isInRoute(location.pathname, singleRoutePath);
  }, [location.pathname, singleRoutePath]);

  return (
    <>
      {itemLink.some((x) => x === singleRoutePath) && (
        <HeaderNavigationItemLinkContainer
          {...props}
          to={singleRoutePath}
          $isActive={isInThisRoute}
          smooth={true}
        >
          {props?.route?.icon && (
            <HeaderNavigationItemIconContainer>
              {props?.route?.icon}
            </HeaderNavigationItemIconContainer>
          )}
          <HeaderNavigationItemIconTitle
            $isActive={isInThisRoute}
            $highlightTitle={highlightTitle}
          >
            {props?.route?.title}
          </HeaderNavigationItemIconTitle>
        </HeaderNavigationItemLinkContainer>
      )}
      {itemHighlight.some((x) => x === singleRoutePath) && (
        <HeaderNavigationItemHighlightContainer
          {...props}
          to={singleRoutePath}
          $isActive={isInThisRoute}
        >
          <HeaderNavigationItemIconTitle
            $isActive={isInThisRoute}
            $highlightTitle={highlightTitle}
          >
            {props?.route?.title}
          </HeaderNavigationItemIconTitle>
          <HighlightIcon />
        </HeaderNavigationItemHighlightContainer>
      )}

      {![...itemLink, ...itemHighlight].some((x) => x === singleRoutePath) && (
        <HeaderNavigationItemContainer
          {...props}
          to={singleRoutePath}
          $isActive={isInThisRoute}
        >
          {props?.route?.icon && (
            <HeaderNavigationItemIconContainer>
              {props?.route?.icon}
            </HeaderNavigationItemIconContainer>
          )}
          <HeaderNavigationItemIconTitle
            $isActive={isInThisRoute}
            $highlightTitle={highlightTitle}
          >
            {props?.route?.title}
          </HeaderNavigationItemIconTitle>
        </HeaderNavigationItemContainer>
      )}
    </>
  );
};

HeaderNavigationItem.propTypes = {
  route: PropTypes.shape({
    icon: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
    title: PropTypes.string,
    subroutes: PropTypes.array,
    route: PropTypes.string,
  }),
};

export default HeaderNavigationItem;
